import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalytics = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .4,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 3,
				y: 15,
				width: 3,
				height: 5,
				rx: 1,
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .6,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 8,
				y: 13,
				width: 3,
				height: 7,
				rx: 1,
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .8,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 13,
				y: 10,
				width: 3,
				height: 10,
				rx: 1,
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18,
			y: 4,
			width: 3,
			height: 16,
			rx: 1,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAnalytics);
export { ForwardRef as ReactComponent };
